import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { LogCapa } from 'src/app/models/SicarMap/LogCapa.model';
import { LogEdicion } from 'src/app/models/SicarMap/LogEdicion.model';
import { environment } from 'src/environments/environment';
import { HttpClientService } from '../implementacion/http-client.service';



@Injectable({
  providedIn: 'root'
})
export class LogsService {

  constructor( private http: HttpClientService ) { }

  RegitrarLog(datos: LogCapa) {
    return this.http.post(`${environment.apiScar}Cartografia/RegistrarLogsCapa`, datos)
      .pipe(map(response => response));
  }

  RegitrarLogEdicion(datos: LogEdicion) {
    return this.http.post(`${environment.apiScar}Cartografia/RegistrarLogsEdicion`, datos)
      .pipe(map(response => response));
  }
}
